export enum ContestStatusLocal{
    NotStarted = 0,
    Started = 1,
    Ended = 2,
    ResultDeclared = 3
}